import { render, staticRenderFns } from "./DenouncesPrescriber.vue?vue&type=template&id=62f2d46a&scoped=true&"
import script from "./DenouncesPrescriber.vue?vue&type=script&lang=ts&"
export * from "./DenouncesPrescriber.vue?vue&type=script&lang=ts&"
import style0 from "./DenouncesPrescriber.vue?vue&type=style&index=0&id=62f2d46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f2d46a",
  null
  
)

export default component.exports